import { IFontFace, SupportedFontTypes, SupportedFonts } from '../types';

export const fontFace: IFontFace[] = [
  {
    name: 'sofia_pro_bold',
    sources: [{ source: SupportedFonts.SofiaProBold, type: SupportedFontTypes.woff2 }],
    style: 'normal',
    weight: 'bold',
    display: 'swap',
  },
  {
    name: 'sofia_pro',
    sources: [{ source: SupportedFonts.SofiaProRegular, type: SupportedFontTypes.woff2 }],
    style: 'normal',
    weight: 'normal',
    display: 'swap',
  },
];
